module.exports = __webpack_public_path__ + "img/6.6e30c6da.jpg";